import { StickerSquare } from "untitledui-js-base";
import { ActivityItem } from "./types";
import { TimeLine, TimeLineItem } from "shared/components/TimeLine";
import { BulletItem } from "shared/app/ActivityLog/BulletItem";
import { ActivityNote } from "shared/app/ActivityLog/ActivityNote";
import type { ActivityApplicant } from "shared/app/ActivityLog/helpers";

export const ActivitiesList = ({
  activityLogs,
  applicationId,
  applicants,
  closeActivityLog
}: {
  applicationId?: string;
  applicants?: ActivityApplicant[];
  activityLogs: ActivityItem[];
  propertyName?: string;
  closeActivityLog?: () => void;
}) => {
  return (
    <div className="flex flex-col h-full">
      <div className="h-full">
        {!activityLogs.length ? (
          <div className="mt-8 flex flex-auto flex-col items-center justify-center">
            <div className="mb-6 flex h-[64px] w-[64px] items-center justify-center rounded-full bg-alpha-40 p-5">
              <StickerSquare size="24" className="stroke-content-500" />
            </div>
            <p className="text-sm font-medium text-content-300">No logs yet</p>
          </div>
        ) : (
          <div className="px-6 size-full flex-1 overflow-x-hidden overflow-y-auto hide-scroll bg-background-900">
            <TimeLine wrapperClassName="ml-4 border-alpha-100 pt-1 w-full">
              {activityLogs.map((activity) => {
                let decisionStatus = "";
                if (
                  activity.details &&
                  typeof activity.details === "object" &&
                  "status" in activity.details
                )
                  decisionStatus = activity.details.status;

                return (
                  <TimeLineItem
                    bullet={
                      <BulletItem
                        activityItem={activity}
                        decisionStatus={decisionStatus}
                      />
                    }
                    wrapperClassName="mt-8"
                    key={
                      activity.updated_at +
                      activity.activity_type +
                      activity.created_at
                    }
                    childrenClassName="w-full"
                  >
                    <ActivityNote
                      activityItem={activity}
                      applicationId={applicationId}
                      applicants={applicants}
                      closeActivityLog={closeActivityLog}
                    />
                  </TimeLineItem>
                );
              })}
            </TimeLine>
          </div>
        )}
      </div>
    </div>
  );
};
